<script lang="ts">
	import { format } from 'svelte-i18n';
	import {
		is_enable_disable_scene_action_ui,
		is_play_scene_action_ui,
	} from '../../../../../../../../types/SceneActionUI';
	import { Text, SelectCard, CardGrid } from '@Shelly/shelly-design-system';
	import { capFirstChar } from '../../../../../../../../helpers/utilities';
	import { DO_WIZARD_STEPS_INDEXES } from '../../helpers/do-wizard-helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let sceneData: any;

	const fullFillOptionsList = [
		{
			title: $format('scene_with_if_evaluation_action', {
				default: 'Start scene, evaluate conditions and then do actions if needed',
			}),
			desc: $format('scene_with_if_evaluation_action_desc', {
				default: 'Evaluate ‘When” conditions and then execute ‘Do’ actions if needed',
			}),
			id: 'with_if_evaluation',
		},
		{
			title: $format('scene_without_if_evaluation_action', {
				default: 'Start scene and directly execute action part',
			}),
			desc: $format('scene_without_if_evaluation_action_desc', {
				default: 'Execute ‘Do’ actions without evaluating ‘When’ conditions.',
			}),
			id: 'without_if_evaluation',
		},
		{
			title: $format('action_enable_scene', {
				default: 'Enable scene',
			}),
			id: 'action_enable_scene',
		},
		{
			title: $format('action_disable_scene', {
				default: 'Disable scene',
			}),
			id: 'action_disable_scene',
		},
		{
			title: $format('action_toggle_scene', {
				default: 'Toggle scene',
			}),
			id: 'action_toggle_scene',
		},
	];

	if (
		is_play_scene_action_ui(sceneData.translated) ||
		is_enable_disable_scene_action_ui(sceneData.translated)
	) {
		sceneData.sceneAction.option = fullFillOptionsList.find(
			(el) => el.id === sceneData.translated.option,
		)?.id;
	}

	const validateWizardStepChangeState = () => {
		sceneData.isValid = true;
		sceneData.validStepIndex = DO_WIZARD_STEPS_INDEXES.SCENE_AS;
	};

	const onSelectExecutionOption = (id) => {
		validateWizardStepChangeState();
		sceneData.sceneAction.option = id;
	};
</script>

<Text element="h2" class="mb-s">
	{capFirstChar($format('scene_execution_options', { default: 'Fullfil scene as' }))}
</Text>

<CardGrid gridGap="s" lg={290} sm={270} noPaddingBottom>
	{#each fullFillOptionsList as option, i}
		<div class="d-flex">
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				class="width-full"
				type="horizontal"
				variant="radio"
				title={option.title}
				descriptiveText={option.desc}
				selected={sceneData.sceneAction.option === option.id}
				on:click={() => {
					onSelectExecutionOption(option.id);
				}}
			/>
		</div>
	{/each}
</CardGrid>
